// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3Py7Q","rootSmall":"AddTileButton_rootSmall__1B7vF"};